var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "social-tabs" }, [
    _c(
      "ul",
      { staticClass: "nav nav-tabs" },
      [
        _c(
          "b-nav-item",
          {
            attrs: {
              to: { name: _vm.socialGroupBy },
              title: "Content Calendar"
            }
          },
          [_vm._v("\n\t\t\t\tContent Calendar\n\t\t\t")]
        ),
        _vm._v(" "),
        _c(
          "b-nav-item",
          {
            attrs: {
              to: { name: "socialMediaSchedule" },
              title: "Scheduled Content"
            }
          },
          [_vm._v("\n\t\t\t\tScheduled Content\n\t\t\t")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }